/* eslint-disable no-unused-vars */
// noinspection JSUnusedGlobalSymbols
export enum BlockType {
  RichTextBlock = 'RichTextBlock',
  ImageBlock = 'ImageBlock',
}
